<script setup lang="ts">
defineProps<{
  product: any
}>()
</script>

<template>
  <div
    v-for="variantCollection in product?.productVariants"
    :key="`variants-${variantCollection.key}`"
  >
    <ProductColorVariants
      v-if="variantCollection.key === 'color'"
      :product="product"
      :variant-collection="variantCollection"
    />
    <div
      v-else-if="variantCollection.items.length > 1"
      class="variations variations--shapes"
    >
      <div class="variations__heading">
        {{ $t(variantCollection.key) }}: {{ variantCollection.current }}
      </div>

      <ul class="variations__list">
        <li
          v-for="option in variantCollection.items"
          :key="option"
          class="variations__item"
        >
          <AppLink
            :to="option.product.url"
            :class="{ variations__link: true, current: option.value === variantCollection.current }"
          >
            {{ option.value }}
          </AppLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style>
@import url("~layers/components/Product/Variants.css");
</style>
